import { render, staticRenderFns } from "./DistributionOrderPaymentStatus.vue?vue&type=template&id=71ba6670&scoped=true&"
import script from "./DistributionOrderPaymentStatus.vue?vue&type=script&lang=js&"
export * from "./DistributionOrderPaymentStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ba6670",
  null
  
)

export default component.exports